








import { Component, Vue } from 'vue-property-decorator'
import Foyer from '@/views/profile/Foyer.vue'

@Component({
    components: {
        Foyer,
    },
})
export default class FoyerFunnel extends Vue {}
